import axios from 'axios';

const TOKEN_KEY = 'sellrec_admin_token';
const EMAIL_KEY = 'sellrec_admin_email';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getAdminEmail = () => localStorage.getItem(EMAIL_KEY);
export const isAuthenticated = () => !!getToken();

export const setSession = (token, email) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(EMAIL_KEY, email);
};

export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EMAIL_KEY);
};

// Attach Authorization header on every request
axios.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401 from admin endpoints, clear session and redirect to /admin/login
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      const url = error.config?.url || '';
      // Only handle admin endpoints (skip public form submissions)
      const adminPaths = ['/auth/me', '/applications', '/contacts', '/download-cv', '/job-offers', '/subcontract-requests'];
      const isAdminCall = adminPaths.some((p) => url.includes(p));
      const isNotLogin = !url.includes('/auth/login');
      if (isAdminCall && isNotLogin && getToken()) {
        clearSession();
        if (window.location.pathname.startsWith('/admin')) {
          window.location.href = '/admin/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return 'Qualcosa è andato storto. Riprova.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ');
  }
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
};
